import { Component, OnInit } from '@angular/core';
import { ContactUsComponent } from '../../contact-us/contact-us.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SharingService } from '../../../services/share.service';
import { CommonModule, DatePipe } from '@angular/common';
import { UTILITY } from '../../../services/util';

@Component({
  selector: 'app-service-details',
  imports: [CommonModule, ContactUsComponent, RouterModule],
  templateUrl: './service-details.component.html',
  styleUrl: './service-details.component.scss',
  providers: [DatePipe],
})
export class ServiceDetailsComponent implements OnInit {

  eventId: any;
  eventDetails: any = null;
  imgURL: any;
  loader: boolean = false;
  dateFormat = UTILITY.Date;
  dateTimeFormat = UTILITY.DateTime;
  attendeesDetails: any = [];
  confirmedAttendeesDetails: string[] = [];
  constructor(
    private svc: SharingService,
    private route: ActivatedRoute
  ) {
    this.imgURL = this.svc.base_Url.slice(0, -4);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.eventId = +id;  // convert to number
        this.getEventDetails();
        this.getAttendeesList()
      }
    });
  }
  convert24hTo12h(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hour12 = ((hours + 11) % 12 + 1);
    return `${hour12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${suffix}`;
  }
  getEventDetails() {
    var url = 'GetEventList';
    let payload = {
      status: 1,
      "is_public": 1
    };
    this.loader = true;
    this.svc.postData(url, payload).subscribe((res: any) => {
      this.loader = false;
      if (res?.data?.length) {
        this.eventDetails = res.data.find((event: any) => event.id === this.eventId);
        this.eventDetails.start_time = this.convert24hTo12h(this.eventDetails?.start_time);
        this.eventDetails.end_time = this.convert24hTo12h(this.eventDetails?.end_time);
        const confirmAttendeesStringtemp =  this.eventDetails?.confirm_attendees || '';
        this.confirmedAttendeesDetails = confirmAttendeesStringtemp
          .split(',')
          .map((s: string) => s.trim())
          .filter((s: string) => s);
      }
    }, err => {
      this.loader = false;
      // handle error
    });
  }
  getAttendeesList() {
    var url = 'GetAttendeesList';
    let payload = {
      event_id: this.eventId,
    };
    this.loader = true;
    this.svc.postData(url, payload).subscribe((res: any) => {
      this.loader = false;
      if (res?.data?.length) {
        for(let i = 0; i<res.data.length; i++){
          const first = res.data[i]?.member?.firstname ?? '';
          const last = res.data[i]?.member?.lastname ?? '';
          res.data[i].member.name = `${first} ${last}`.trim();
          this.attendeesDetails.push(res.data[i].member);
        }        
      }
    }, err => {
      this.loader = false;
      // handle error
    });
  }

}
